/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnknownClientDetailsResource
 */
export interface UnknownClientDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof UnknownClientDetailsResource
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UnknownClientDetailsResource
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UnknownClientDetailsResource
     */
    lastName: string;
}

/**
 * Check if a given object implements the UnknownClientDetailsResource interface.
 */
export function instanceOfUnknownClientDetailsResource(value: object): value is UnknownClientDetailsResource {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function UnknownClientDetailsResourceFromJSON(json: any): UnknownClientDetailsResource {
    return UnknownClientDetailsResourceFromJSONTyped(json, false);
}

export function UnknownClientDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnknownClientDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function UnknownClientDetailsResourceToJSON(value?: UnknownClientDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

